import Loading from "./Loading";

export default function TailwindDataTable({
    data,
    columns,
    theadClasses = "bg-darkBlue",
    thClasses = "",
    loading = false,
}) {
    if (!columns && !columns?.length) {
        return (
            <>
                <div className="flex flex-center h-full">
                    <p className="text-gray-500 text-xl font-medium">No Columns Found</p>
                </div>
            </>
        );
    }
    return (
        <div className="w-full overflow-auto border rounded-lg">
            <table className="table rounded-lg overflow-hidden w-full">
                <thead className={theadClasses || ""}>
                    <tr>
                        {columns?.map((column, rowIndex) => (
                            <th
                                key={column.key + "head" + rowIndex}
                                className={`px-3 py-3 font-semibold ${column.hidden ? "hidden" : ""
                                    } capitalize tracking-wider bg-blue-200 border-gray-500 !text-black ${column?.headerClasses || ""
                                    } ${thClasses || ""}`}
                                onClick={() => {
                                    column.headerOnClick &&
                                        column.headerOnClick(column, rowIndex);
                                }}
                            >
                                <div
                                    className="flex justify-between items-center"
                                    role={column?.sort && "button"}
                                >
                                    {column.label}
                                    {column.headerHTMLAddon &&
                                        column.headerHTMLAddon(column, rowIndex)}
                                </div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr className="bg-white">
                            <td className="px-3 py-3 " colSpan={columns.length}>
                                <div className="w-full flex justify-center py-7">
                                    <Loading />
                                </div>
                            </td>
                        </tr>
                    ) : !data?.length ? (
                        <tr className="bg-white">
                            <td className="px-5 pb-3" colSpan={columns.length}>
                                <div className="w-full flex flex-col items-center">
                                    <div className="text-2xl font-bold text-darkBlue mt-7">
                                        No Data Found
                                    </div>
                                </div>
                            </td>
                        </tr>
                    ) : (
                        data?.map((row, rowIndex) => (
                            <tr key={rowIndex} className="bg-white">
                                {columns?.map((column, columnIndex) => (
                                    <td
                                        key={column.key + columnIndex}
                                        className={`px-3 ${column.hidden ? "hidden" : ""
                                            } py-3 border-b-2  border-gray-100`}
                                    >
                                        {column?.hasOwnProperty("formatter")
                                            ? column.formatter(row[column.key], row, rowIndex)
                                            : row[column.key || column.label]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
